import React, { useEffect, useState, useCallback } from 'react';

import { hasRoles, CREATE_CAPA_REVIEW_ROLES } from '../../../../util/RoleUtil';

import { retrieveCAPAs } from '../../../../services/CAPAService';

import { Table } from '../../../common/table/Table';

export const CAPAReviewSearch = ({ navigateTo, navigateToWith, context, setSpinnerText, showToaster }) => {
  const [searchResults, setSearchResults] = useState([]);

  const retrieveAllCapas = useCallback(async () => {
    setSpinnerText('Retrieving CAPAs');
    const [data, error] = await retrieveCAPAs(context.username);
    if (data) {
      if (data.responseStatus === 'Success') {
        setSearchResults(data.capas);
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
  }, [context, setSpinnerText, showToaster]);

  useEffect(() => {
    retrieveAllCapas();
  }, [retrieveAllCapas]);

  if (!searchResults) return null;

  const handleRowClick = (capa) => {
    navigateToWith('capaReviewsEdit', 'capaReviewCreateGeneral', capa);
  };

  const handleAddButtonClick = () => {
    navigateTo('capaReviewsCreate');
  };

  return (
    <Table
      tableData={searchResults}
      filterEnabled={true}
      tableTitle={'CAPA Reviews'}
      buttonText={hasRoles(context, CREATE_CAPA_REVIEW_ROLES) ? 'Create New' : undefined}
      onButtonClick={handleAddButtonClick}
      onRowClick={handleRowClick}
      maxRowCount={10}
      buttonOneWidth={'135px'}
      hiddenColumns={['externalReference', 'isDeleted', 'lastModified', 'created']}
      searchEnabled
      horizontalScroll
    />
  );
};
